export const FORM_INPUT_TEXT = 'Enter Activation Key'
export const FORM_PLACEHOLDER_TEXT = 'ex: SSP0FAMILY99'
export const SENDING_PAK_NUMBER = 'Submitting PAK number...'
export const ERROR_MESSAGE = 'Please enter a valid Activation Key'
export const SUBMIT_BUTTON = 'Activate'
export const CANCEL_BUTTON = 'Cancel'
export const TERMS_DESC = `By accessing or using Second Step® programs, you agree to the `
export const LOADING_TEXT_DASHBOARD_KITS = 'Loading Kits...'
